<template lang="pug">
  v-textarea(
    v-model="routeState.dataState.data.content"
    filled
    label="Que voulez-vous dire ?"
    single-line
    :counter="800"
    :rules="[value => !!value || `Le contenu est obligatoire`, $createLengthRule({ max: 800, label: `La publication` })]")
</template>

<script>
import { injectRouteState } from '@iez/core'

export default {
  setup () {
    const routeState = injectRouteState()

    return {
      routeState
    }
  }
}
</script>
